import React from "react";

function FeedbackState({
	variant = "empty",
	title,
	description,
	actionLabel,
	onAction,
	compact = false,
}) {
	return (
		<div
			className={`feedback-state feedback-state-${variant} ${
				compact ? "feedback-state-compact" : ""
			}`}
			role={variant === "error" ? "alert" : "status"}
		>
			<div className='feedback-state-icon' aria-hidden='true'>
				{variant === "loading" ? "..." : variant === "error" ? "!" : "i"}
			</div>
			<div className='feedback-state-copy'>
				<h3 className='feedback-state-title'>{title}</h3>
				{description && <p className='feedback-state-description'>{description}</p>}
			</div>
			{actionLabel && onAction && (
				<button
					type='button'
					className='btn btn-light feedback-state-action'
					onClick={onAction}
				>
					{actionLabel}
				</button>
			)}
		</div>
	);
}

export { FeedbackState };
